import React from 'react'
import styled from 'styled-components'

const Close = styled.div`
  svg {
    transition: ease transform 0.2s;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
      transition: ease transform 0.2s;
    }
  }
`

const CloseIcon = props => (
  <Close {...props}>
    <svg width='24' height='24' viewBox='0 0 24 24'>
      <path d='M12,13.4142136 L5.70710678,19.7071068 C5.31658249,20.0976311 4.68341751,20.0976311 4.29289322,19.7071068 C3.90236893,19.3165825 3.90236893,18.6834175 4.29289322,18.2928932 L10.5857864,12 L4.29289322,5.70710678 C3.90236893,5.31658249 3.90236893,4.68341751 4.29289322,4.29289322 C4.68341751,3.90236893 5.31658249,3.90236893 5.70710678,4.29289322 L12,10.5857864 L18.2928932,4.29289322 C18.6834175,3.90236893 19.3165825,3.90236893 19.7071068,4.29289322 C20.0976311,4.68341751 20.0976311,5.31658249 19.7071068,5.70710678 L13.4142136,12 L19.7071068,18.2928932 C20.0976311,18.6834175 20.0976311,19.3165825 19.7071068,19.7071068 C19.3165825,20.0976311 18.6834175,20.0976311 18.2928932,19.7071068 L12,13.4142136 Z' />
    </svg>
  </Close>
)

export default CloseIcon



// WEBPACK FOOTER //
// ./src/svg-icons/CloseIcon.js